import React from 'react';
import Toast from './Toast';
import _ from 'lodash';

class UndoToast extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };

    _.map(['handleUndo', 'handleClose'], (fn) => {
      this[fn] = this[fn].bind(this);
    });
  }

  componentDidMount() {
    this.setState({ ...this.state, isOpen: true });
  }

  handleClose() {
    const { onClose } = this.props;

    if (onClose) {
      onClose();
    }

    this.setState({ ...this.state, isOpen: false });
  }

  handleUndo() {
    const { onUndo } = this.props;

    onUndo();
    this.handleClose();
  }

  render() {
    const { label, customClass, undoDone } = this.props;
    const { isOpen } = this.state;
    const undoButton = !undoDone ? (
      <a onClick={this.handleUndo}> Click here to undo this action .</a>
    ) : null;

    return (
      <Toast
        open={isOpen}
        onClose={this.handleClose}
        timer={10000}
        classes={{ options: customClass }}
      >
        <span>
          {label} {undoButton}{' '}
        </span>
        ;
      </Toast>
    );
  }
}

export default UndoToast;
